import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
let UiSettingsApiService = class UiSettingsApiService {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
        this._endpointUrl = '/me/ui-settings';
    }
    getUiSettings() {
        return of({
            grid_settings: null,
            dashboard_settings: null,
            modal_settings: null,
            config_settings: null,
            theme_settings: {
                selected_color_scheme: localStorage.getItem('selected_color_scheme') || 'Purple Light',
            },
            tutorial_settings: { skip_tutorial: !!localStorage.getItem('skip_tutorial') },
        }); // this._httpClient.get<IUiSettings>(this._endpointUrl).pipe(pluck('data', 'ui_settings'));
    }
    saveGridSettings(body) {
        if (!body.length) {
            return of({});
        }
        return of(body); // this._httpClient.put<IGridSettings>(`${this._endpointUrl}/grid`, body);
    }
    saveDashboardSettings(body) {
        if (!Object.keys(body.ui_settings).length) {
            return of({});
        }
        return this._httpClient.put(`${this._endpointUrl}/dashboard`, {
            dashboard_id: body.dashboard_id,
            ui_settings: body.ui_settings,
        });
    }
    saveModalSettings(body) {
        if (!Object.keys(body.modal_settings).length) {
            return of({});
        }
        return this._httpClient.put(`${this._endpointUrl}/modal`, {
            modal_id: body.modal_id,
            ui_settings: body.modal_settings,
        });
    }
    updateColorSchemes(schemes) {
        return this._httpClient.put(`${this._endpointUrl}/color-schemes`, schemes);
    }
    skipTutorial() {
        return of({ skip_tutorial: true }); // this._httpClient.put<any>(`${this._endpointUrl}/tutorial`, { skip_tutorial: true });
    }
    updateConfigSettings(configSettings) {
        if (!Object.keys(configSettings).length) {
            return of({});
        }
        const body = {
            config_settings: configSettings,
        };
        return this._httpClient.put(`${this._endpointUrl}/config`, body);
    }
};
UiSettingsApiService.ctorParameters = () => [
    { type: HttpClient }
];
UiSettingsApiService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClient])
], UiSettingsApiService);
export { UiSettingsApiService };
